<template>
<div>
    <LogoToggle :showStatus="isCollapse" :logoMsg="logoMsg" class="logo"></LogoToggle>
      <el-menu
        class="navbar"
        :default-active="selectMenuId"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
        mode="horizontal"
        @select="handleSelect"
      >
        <navmenu
          v-for="sitemap in sitemapList"
          :key="sitemap.sitemapId"
          :item="sitemap"
          class="navmenu"
        />
      </el-menu>
    <rightmenu class="right-menu" />
  </div>
</template>
<script>
import { generateTitle } from "@/utils/i18n";
import { mapGetters } from "vuex";
import navmenu from "./navmenu";
import rightmenu from "./rightmenu";
import variables from "@/styles/variables.scss";
import LogoToggle from "@/components/LogoToggle";
export default {
  name: "NavbarTop",
  data() {
    return {
      // 传入 logo 文件名
      logoMsg: {
        logoFileName: "defaultLogo",
        projectName: ""
      },
    };
  },
  components: { navmenu, LogoToggle, rightmenu },

  methods: {
    generateTitle,
    
    handleSelect(key, keyPath) {
      //将点击的一级菜单的id存入vuex
        this.$store.commit("SET_SELECT_MENU_ID", key + "");
    },
    
  },
  computed: {
    ...mapGetters(["sitemapList", "sidebar", "selectMenuId"]),
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
};
</script>
 <style  lang="scss" >
</style>